export enum FolxMembershipStatus {
	ACTIVE = 'ACTIVE',
	CANCELED = 'CANCELED',
	CANCELING = 'CANCELING',
	PAST_DUE = 'PAST_DUE',
	UNPAID = 'UNPAID',
	UNKNOWN = 'UNKNOWN',
	INCOMPLETE = 'INCOMPLETE',
	EXPIRED = 'INCOMPLETE_EXPIRED',
}
